import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllSliders,
  insertSlider,
  editSlider,
  deleteSlider,
} from "./SliderThunks";

// Slice
const sliderSlice = createSlice({
  name: "sliders",
  initialState: {
    fetchSlidersPending: false,
    sliderList: null,
    pagination: null,
    fetchSlidersRejected: null,
    insertSliderPending: false,
    insertSliderFulfilled: null,
    insertSliderRejected: null,
    editSliderPending: false,
    editSliderFulfilled: null,
    editSliderRejected: null,
    deleteSliderPending: false,
    deleteSliderFulfilled: null,
    deleteSliderRejected: null,
  },
  reducers: {
    resetInsertSlider: (state) => {
      state.insertSliderPending = false;
      state.insertSliderFulfilled = null;
      state.insertSliderRejected = null;
    },
    resetEditSlider: (state) => {
      state.editSliderFulfilled = null;
      state.editSliderRejected = null;
      state.editSliderPending = false;
    },
    resetDeleteSlider: (state) => {
      state.deleteSliderFulfilled = false;
      state.deleteSliderRejected = null;
      state.deleteSliderPending = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch all sliders
    builder
      .addCase(fetchAllSliders.pending, (state) => {
        state.fetchSlidersPending = true;
        state.fetchSlidersRejected = null;
      })
      .addCase(fetchAllSliders.fulfilled, (state, action) => {
        state.fetchSlidersPending = false;
        state.sliderList = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchAllSliders.rejected, (state, action) => {
        state.fetchSlidersPending = false;
        state.fetchSlidersRejected = action.payload;
      });

    // Insert new slider
    builder
      .addCase(insertSlider.pending, (state) => {
        state.insertSliderPending = true;
        state.insertSliderRejected = null;
      })
      .addCase(insertSlider.fulfilled, (state, action) => {
        state.insertSliderPending = false;
        state.insertSliderFulfilled = action.payload;
      })
      .addCase(insertSlider.rejected, (state, action) => {
        state.insertSliderPending = false;
        state.insertSliderRejected = action.payload;
      });

    // Edit slider
    builder
      .addCase(editSlider.pending, (state) => {
        state.editSliderPending = true;
        state.editSliderRejected = null;
      })
      .addCase(editSlider.fulfilled, (state, action) => {
        state.editSliderPending = false;
        state.editSliderFulfilled = action.payload;
      })
      .addCase(editSlider.rejected, (state, action) => {
        state.editSliderPending = false;
        state.editSliderRejected = action.payload;
      });

    // Delete slider
    builder
      .addCase(deleteSlider.pending, (state) => {
        state.deleteSliderPending = true;
        state.deleteSliderRejected = null;
      })
      .addCase(deleteSlider.fulfilled, (state, action) => {
        state.deleteSliderPending = false;
        state.deleteSliderFulfilled = action.payload;
      })
      .addCase(deleteSlider.rejected, (state, action) => {
        state.deleteSliderPending = false;
        state.deleteSliderRejected = action.payload;
      });
  },
});

export const { resetInsertSlider, resetEditSlider, resetDeleteSlider } =
  sliderSlice.actions;

export default sliderSlice.reducer;
